module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_vm._v("\n\nSiamo spiacenti il gestionale è chiuso. \n\n\n\n\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d75f5dd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chiuso.vue
// module id = 605
// module chunks = 2